import { render, staticRenderFns } from "./PastPrestigeRunsTab.vue?vue&type=template&id=34e05178"
import script from "./PastPrestigeRunsTab.vue?vue&type=script&lang=js"
export * from "./PastPrestigeRunsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports